var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":_vm.dataSource.type || 'line',"height":_vm.dataSource.height,"options":_vm.dataSource.chartOptions,"series":_vm.dataSource.series}})}
var staticRenderFns = []

export { render, staticRenderFns }